<script setup lang="ts">
/**
 * NuxtLink that stays in the reader's language: on a Czech page "/pricing"
 * links to "/cs/pricing" (composables/useLocalizedPath.ts). Use it for every
 * internal link outside the admin; everything but `to`/`href` passes through.
 */
import type { RouteLocationRaw } from 'vue-router'

const props = defineProps<{
  to?: RouteLocationRaw
  href?: RouteLocationRaw
}>()

const localize = useLocalizedPath()
const target = computed(() => localize(props.to ?? props.href))
</script>

<template>
  <NuxtLink :to="target">
    <slot />
  </NuxtLink>
</template>
